import { CheckIcon } from "@chakra-ui/icons";
import { GridItem, Link, List, ListIcon, ListItem, Text } from "@chakra-ui/react";
import { ReactNode } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { ContentPanel } from "../../../components/content-panel";
import { DownloadDesktopClientButton } from "../../../components/download-desktop-client-button";
import { DASHBOARD_GRID_ITEM_HEIGHT } from "../tenant-details";

export const DownloadDesktopRanaBlock = () => {
  const intl = useIntl();

  return (
    <GridItem colStart={{ lg: 2 }} rowStart={{ lg: 3 }} height={DASHBOARD_GRID_ITEM_HEIGHT}>
      <ContentPanel
        title={intl.formatMessage({
          id: "dashboard.download_desktop_client",
          defaultMessage: "Rana Desktop Client for Windows",
        })}
      >
        <List spacing={2}>
          <ListItem>
            <ListIcon as={CheckIcon} color="brand.analytic" />
            <FormattedMessage
              id="dashboard.work_offline"
              defaultMessage="<strong>Work</strong> with your hydrological data <strong>offline</strong>"
              values={{
                strong: (chunk: ReactNode[]) => <strong>{chunk}</strong>,
              }}
            />
          </ListItem>
          <ListItem>
            <ListIcon as={CheckIcon} color="brand.analytic" />
            <FormattedMessage
              id="dashboard.pre_installed"
              defaultMessage="Pre-installed with the Rana plugin for <strong>instant access</strong> to your projects"
              values={{
                strong: (chunk: ReactNode[]) => <strong>{chunk}</strong>,
              }}
            />
          </ListItem>
        </List>

        <DownloadDesktopClientButton mt={4} w="full" />
        {/* FUTURE: Hiding the following link until the documentation is ready: */}
        <Text style={{ display: "none" }}>
          <span role="img" aria-label="book">
            📖
          </span>{" "}
          <Link href="https://rana.gitbook.io/rana" target="_blank" rel="noopener noreferrer">
            <FormattedMessage
              id="dashboard.download_learn_more"
              defaultMessage="Learn more about Rana Desktop Client"
            />
          </Link>
        </Text>
      </ContentPanel>
    </GridItem>
  );
};
